import * as React from 'react';

import LockBadge16 from './LockBadge16';

export const lockBadge16 = () => <LockBadge16 />;

export default {
    title: 'Icon|Line|LockBadge16',
    component: LockBadge16,
    parameters: {
        notes: "`import LockBadge16 from 'box-ui-elements/es/icon/line/LockBadge16';`",
    },
};
